import { ApiError } from '../../shared/api/client.js';

/** Functional §9.2: twelve characters minimum, no composition rule. */
export const PASSWORD_RULE =
  'Au moins 12 caractères. Une phrase facile à retenir convient très bien ; les mots de passe trop courants sont refusés.';

const POLICY_MESSAGES: Readonly<Record<string, string>> = {
  too_short: 'Le mot de passe doit compter au moins 12 caractères.',
  too_long: 'Le mot de passe est trop long (256 caractères au plus).',
  compromised: 'Ce mot de passe figure parmi les plus courants : choisissez-en un autre.',
};

export function passwordProblem(cause: unknown): string {
  if (cause instanceof ApiError && cause.code === 'PASSWORD_POLICY_VIOLATION') {
    return POLICY_MESSAGES[cause.detail ?? ''] ?? 'Ce mot de passe est refusé.';
  }
  return "L'enregistrement a échoué. Réessayez.";
}
